'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useEffect, useRef } from 'react';
import { scheduleWhenIdle } from '@module/mdrt-org/shared/utils/helpers/schedule-when-idle';
import { isOfflineWarmingEnabled } from './utils/offline-warm-gate';
import { warmOfflineCache } from './utils/warm-offline-cache';
export const OfflineCacheWarmer = () => {
  const $ = _c(3);
  const locale = useLocale();
  const warmedLocaleRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== locale) {
    t0 = () => {
      if (warmedLocaleRef.current === locale || !isOfflineWarmingEnabled()) {
        return _temp;
      }
      warmedLocaleRef.current = locale;
      const controller = new AbortController();
      const cancelIdle = scheduleWhenIdle(() => {
        warmOfflineCache(locale, controller.signal);
      });
      return () => {
        cancelIdle();
        controller.abort();
      };
    };
    t1 = [locale];
    $[0] = locale;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
};
function _temp() {}